import SalesforceInstallation from "./SalesforceInstallation";

export default SalesforceInstallation;
